export default "__VITE_ASSET__BGANJy03__"